import { Height } from '@mui/icons-material';
import styled from "styled-components";

export const ModalContainer = styled.div<{ isMobile?: boolean }>`
  border-radius: 8px;
  justify-content: center;
  text-align: center;
  align-items: center;
  align-self: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 55vw;
  max-height: 550px;
  min-width: ${(props) => (props.isMobile ? "300px" : "560px")};
  min-height: ${(props) => (props.isMobile ? "400px" : "320px")};
  background-color: #ffffff;
  
 
  width: ${props => props.isMobile ? '90%' : '50%'};
  margin: auto;

  padding: 20px;
  border-radius: 8px;
  overflow: hidden; /* Adicionado overflow: hidden para garantir que a rolagem seja aplicada no conteúdo */
  @media (max-width: 768px) {
    width: 90%;
  }   
  max-height: 92%; 
  overflow-y: scroll;

`;

export const ModalContentContainer = styled.div<{ isMobile?: boolean }>`
  margin-top: ${(props) => (props.isMobile ? "15%" : "5%")};
  margin-left: ${(props) => (props.isMobile ? "10px" : "5%")};
  margin-right: ${(props) => (props.isMobile ? "10px" : "5%")};

`;

export const ButtonAreaContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 760px) {
    flex-direction: column;
  }
`;

export const Div = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const InputGroup = styled.div`
flex: 1 1 45%;
display: flex;
flex-direction: column;
margin: 8px;

@media (max-width: 768px) {
  flex: 1 1 100%;
}
`;

export const ButtonGroup = styled.div`
flex: 1 1 33%;
display: flex;
justify-content: flex-start;
margin: 8px;

@media (max-width: 768px) {
  flex: 1 1 100%;
  justify-content: center;
}
`;

export const Label = styled.label`
  margin-bottom: 4px;
`;